<span
  class="remaining-seconds block"
  [innerHTML]="remainingSecondsText()"></span>
<span class="help-text block"
  >&nbsp;{{ 'auth.continue_browsing_help' | translate }}</span
>

<rd-shared-button
  class="close-button-wrapper"
  [buttonClass]="'close-button'"
  [buttonContent]="buttonContent"
  [buttonTheme]="buttonTheme"
  (clickFn)="close()">
  <ng-template #buttonContent>
    <span class="continue-button-text">
      {{ 'auth.continue_button_text' | translate }}
    </span>
  </ng-template>
</rd-shared-button>
